<template>
    <div class="management">
        <div class="container">
            <div class="top-select">
                <el-select v-model="countryValue" class="select" placeholder="请选择" @change="handleRegion">
                    <el-option v-for="item in wholeCountry" :key="item.value" :label="item.label"
                        :value="{ value: item.value, label: item.label }">
                    </el-option>
                </el-select>
                <el-select v-model="companyValue" class="select" placeholder="请选择" @change="handleCompany">
                    <el-option v-for="item in companies" :key="item.value" :label="item.label"
                        :value="{ value: item.value, label: item.label }">
                    </el-option>
                </el-select>
                <el-date-picker v-model="timer" type="year" placeholder="选择年" @change="handleTime"
                    :picker-options="pickerBeginDateBefore">
                </el-date-picker>
            </div>
            <!-- 顶部 -->
            <div class="top-cont" @mouseover="changIconsBlockPosition('enter', 0)"
                @mouseleave="changIconsBlockPosition('out')">
                <dv-border-box-7>
                    <div class="top-border">
                        <div class="icons-text-block">
                            <div class="icons-text">
                                <p class="top-icon icon-four">运营数据</p>
                            </div>
                            <div class="icons-info">
                                <iconsInfo ref="iconsNin" class="icon-nin" :infoTitle="'运营数据'"
                                    :details="COUNSTDATE.MANAGEMENT_INFO" />
                            </div>
                        </div>
                        <div class="top-data">
                            <div class="top-num1">
                                <div class="top-n">
                                    <div class="top-num">
                                        <animate-number from="1" :to="collectionAmount" :key="collectionAmount"
                                            :formatter="formatter"></animate-number>万
                                    </div>
                                    <p class="top-text1">回款金额</p>
                                </div>
                            </div>
                            <div class="top-num1 top-line">
                                <div class="top-n">
                                    <p class="top-num">
                                        <animate-number from="1" :to="collectionPeriod" :key="collectionPeriod">
                                        </animate-number>天
                                    </p>
                                    <p class="top-text1">客户回款平均周期</p>
                                </div>
                            </div>
                            <div class="top-num1 top-line">
                                <div class="top-n">
                                    <p class="top-num">
                                        <animate-number from="0" :to="customerRate" :key="customerRate">
                                        </animate-number>%
                                    </p>
                                    <p class="top-text1">客户续签率</p>
                                </div>
                            </div>
                            <div class="top-num1 top-line">
                                <div class="top-n">
                                    <p class="top-num">
                                        <animate-number from="0" :to="positionRate" :key="positionRate"
                                            :formatter="formatter"></animate-number>万
                                    </p>
                                    <p class="top-text1">年度人均单产</p>
                                </div>
                            </div>
                            <div class="top-num1 top-line">
                                <div class="top-n">
                                    <p class="top-num">
                                        <animate-number from="0" :to="positionTime" :key="positionTime">
                                        </animate-number>天
                                    </p>
                                    <p class="top-text1">职位交付平均周期</p>
                                </div>
                            </div>
                            <div class="top-num1 top-line">
                                <div class="top-n">
                                    <p class="top-num">
                                        <animate-number from="0" :to="newBillTime" :key="newBillTime"></animate-number>天
                                    </p>
                                    <p class="top-text1">新员工开单平均周期</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </dv-border-box-7>
            </div>
            <!-- 中间 -->
            <div class="middle-cont">
                <div class="middle-block" @mouseover="changIconsBlockPosition('enter', 1)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="middle-data middle-flex">
                            <p class="cont-bg-event">员工业绩偏离折线</p>
                            <div class="icons-block">
                                <iconsBlock ref="iconsFir" class="cont-position":infoTitle="'员工业绩偏离折线'"
                                    :idName="'middleOne'" :stringPaintChart="middleOneData" @download="download"
                                    @changeTextColor="changeTextColor" :details="COUNSTDATE.MANAGEMENT_STAFF" />
                            </div>
                        </div>
                        <div class="width-height">
                            <div id="middleOne" :style="{ width: '100%', height: '100%' }"></div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="middle-block" @mouseover="changIconsBlockPosition('enter', 2)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="middle-data middle-flex">
                            <p class="cont-bg-event">公司业绩等级分布</p>
                            <div class="icons-block">
                                <iconsBlock ref="iconsSec" class="cont-position" :timeArray="timerData" @chooseData="childByValue" :infoTitle="'公司业绩等级分布'"
                                    :idName="idName1" :stringPaintChart="childByValue" @download="download"
                                    @changeTextColor="changeTextColor" :details="COUNSTDATE.MANAGEMENT_COMPANY" />
                            </div>
                        </div>
                        <div class="width-height">
                            <div id="middleTwo" :style="{ width: '100%', height: '100%' }"></div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="middle-block" @mouseover="changIconsBlockPosition('enter', 3)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="middle-data middle-flex">
                            <p class="cont-bg-event">回款客户等级分布</p>
                            <div class="icons-block">
                                <iconsBlock ref="iconsThr" class="cont-position" :timeArray="timerData" @chooseData="childByValue" :infoTitle="'回款客户等级分布'"
                                    :idName="idName2" :stringPaintChart="childByValue" @download="download"
                                    @changeTextColor="changeTextColor" :details="COUNSTDATE.MANAGEMENT_GRADE" />
                            </div>
                        </div>
                        <div class="width-height">
                            <div id="middleThree" :style="{ width: '100%', height: '100%' }"></div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="middle-block" @mouseover="changIconsBlockPosition('enter', 4)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="middle-data middle-flex">
                            <p class="cont-bg-event">客户回款客单价分布</p>
                            <div class="icons-block">
                                <iconsBlock ref="iconsFou" class="cont-position" :timeArray="timerData" @chooseData="childByValue" :infoTitle="'客户回款客单价分布'"
                                    :idName="idName3" :stringPaintChart="childByValue" @download="download"
                                    @changeTextColor="changeTextColor" :details="COUNSTDATE.MANAGEMENT_PRICE" />
                            </div>
                        </div>
                        <div class="width-height" style="height: 70%">
                            <div id="middleFour" :style="{ width: '100%', height: '100%' }"></div>
                            <div class="legendData">
                                <span> <i class="legendOne"></i> v0</span>
                                <span> <i class="legendTwo"></i> v1-v2</span>
                                <span> <i class="legendThree"></i> v3-v4</span>
                                <span> <i class="legendFour"></i> v5</span>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
            </div>
            <!-- 底部 -->
            <div class="middle-cont">
                <div class="middle-block" @mouseover="changIconsBlockPosition('enter', 5)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="middle-data middle-flex" style="height: 14%">
                            <p class="top-icon icon-six">招聘数据</p>
                            <div class="icons-block">
                                <iconsBlock ref="iconsFiv" class="cont-position" :infoTitle="'招聘数据'"
                                    :idName="'bottomOne'" :stringPaintChart="bottomOneData" @download="download"
                                    @changeTextColor="changeTextColor" :details="COUNSTDATE.MANAGEMENT_ALL" />
                            </div>
                        </div>
                        <div class="width-height">
                            <div id="bottomOne" :style="{ width: '100%', height: '100%' }"></div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="middle-block" @mouseover="changIconsBlockPosition('enter', 6)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="middle-data middle-flex" style="height: 14%">
                            <p class="top-icon icon-six">员工职级分布</p>
                            <div class="icons-block">
                                <iconsBlock ref="iconsSix" class="cont-position" :timeArray="timerData" @chooseData="childByValue" :infoTitle="'员工职级分布'"
                                    :idName="idName4" :stringPaintChart="childByValue" @download="download"
                                    @changeTextColor="changeTextColor" :details="COUNSTDATE.MANAGEMENT_STAFF_GRADE" />
                            </div>
                        </div>
                        <div class="width-height">
                            <div id="bottomTwo" :style="{ width: '100%', height: '100%' }"></div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="middle-block" @mouseover="changIconsBlockPosition('enter', 7)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="middle-data middle-flex" style="height: 14%">
                            <p class="top-icon icon-six">员工学历分布</p>
                            <div class="icons-block">
                                <iconsBlock ref="iconsSev" class="cont-position" :timeArray="timerData" @chooseData="childByValue" :infoTitle="'员工学历分布'"
                                    :idName="idName5" :stringPaintChart="childByValue" @download="download"
                                    @changeTextColor="changeTextColor" :details="COUNSTDATE.MANAGEMENT_EDUCATION" />
                            </div>
                        </div>
                        <div class="width-height">
                            <div id="bottomThree" :style="{ width: '100%', height: '100%' }"></div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="middle-block" @mouseover="changIconsBlockPosition('enter', 8)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="middle-data middle-flex" style="height: 14%">
                            <p class="cont-bg-event">不同周期离职人数</p>
                            <div class="icons-block">
                                <iconsBlock ref="iconsEig" class="cont-position" :timeArray="timerData" @chooseData="childByValue" :infoTitle="'不同周期离职人数'"
                                    @download="download" :idName="idName6" :stringPaintChart="childByValue"
                                    @changeTextColor="changeTextColor" :details="COUNSTDATE.MANAGEMENT_QUIT" />
                            </div>
                        </div>
                        <div class="width-height">
                            <div id="bottomFour" :style="{ width: '100%', height: '100%' }"></div>
                        </div>
                    </dv-border-box-7>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    GetStaffPerformance,
    GetRegionalPerformanceGrade,
    GetRegionalPerformanceGradeByDateRange,
    GetRegionalClientGrade,
    GetRegionalClientGradeIncomeCycleByDateRange,
    GetRegionalClientUnitPrice,
    GetRegionalClientUnitPriceByDateRange,
    GetRegionalCounselorPosition,
    GetRegionalCounselorPositionByDateRange,
    GetRegionalStaffEducation,
    GetRegionalStaffEducationByDateRange,
    GetRegionalStaffLeaveCycle,
    GetRegionalStaffLeaveCycleByDateRange,
    GetStaffCount,
    GetRegionComboBox,
    GetCompaniesData,
    GetManageDate,
} from "@/api/api";
import { exportImg } from "../../utils/downLoad.js";
import iconsBlock from "./iconsBlock/index.vue";
import iconsInfo from "./iconsBlock/iconsInfo.vue";
import COUNSTDATE from "../../constants/index";
import { conversionUnit } from "../../utils/utils";

export default {
    components: {
        iconsBlock,
        iconsInfo,
    },
    data() {
        return {
            COUNSTDATE: COUNSTDATE,
            urlData: "",
            idName1:"middleTwo",
            idName2:"middleThree",
            idName3:"middleFour",
            idName4:"bottomTwo",
            idName5:"bottomThree",
            idName6:"bottomFour",
            timerData:[],
            timer: new Date(),
            collectionAmount: "0",
            collectionPeriod: "0",
            customerRate: "0",
            positionRate: "0",
            positionTime: "0",
            newBillTime: "0",
            isChildText: false,
            countryId: 0,
            countryValue: "",
            wholeCountry: [],
            companyId: 0,
            companyValue: "",
            companies: [],
            checkId: 0,
            pickerBeginDateBefore: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            regionId:0,
            companyIded:0,
            curDate:"",
            curDate:"",
        };
    },
    computed: {
        isTextColor() {
            return this.isChildText ? "#000" : "#fff";
        },
        getYear() {
            return new Date(this.timer).getFullYear() || new Date().getFullYear();
        },
        params() {
            return {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                ticket: this.urlData,
            };
        },
    },
    created() {
        this.urlData = sessionStorage.getItem("urlData");
    },
    mounted() {
        this.etCountDays()
        this.onClick()
        this.twoClick()
        this.comboBoxData();


    },
    methods: {
        etCountDays() {
            let curDate = new Date()
            let curMonth = curDate.getMonth()
            curDate.setMonth(curMonth + 1)
            curDate.setDate(0)
            /* 返回当月的天数和月份 */
            this.curDate=curDate.getDate()
            return { day: curDate.getDate(), month: curMonth + 1 }
        },
        childByValue(data,value,countryValue,companyValue) {
            if (data != undefined){
            this.timerData=value

            console.log('[ value123 ] >', value)

            var arr=value[1].substring(5,7)
            if(arr=="01"){
                this.curTime="-31"
            }else if(arr=="02"){
                this.curTime="-28"
            }else if(arr=="03"){
                this.curTime="-31"
            }else if(arr=="04"){
                this.curTime="-30"
            }else if(arr=="05"){
                this.curTime="-31"
            }else if(arr=="06"){
                this.curTime="-30"
            }else if(arr=="07"){
                this.curTime="-31"
            }else if(arr=="08"){
                this.curTime="-31"
            }else if(arr=="09"){
                this.curTime="-30"
            }else if(arr=="10"){
                this.curTime="-31"
            }else if(arr=="11"){
                this.curTime="-30"
            }else if(arr=="12"){
                this.curTime="-31"
            }



            this.regionId=countryValue
            this.companyIded=companyValue.value
            }
            if (data == undefined) {
                // if(this.idName1!=""){
                //     this.middleTwoDataTwo()
                // }
                // if(this.idName2!=""){
                //     this.middleThreeDataTwo()
                // }
                // if(this.idName3!=""){
                //     this.middleFourDataTwo()
                // }
                // if(this.idName4!=""){
                //     this.bottomTwoDataTwo()
                // }
                // if(this.idName5!=""){
                //     this.bottomThreeDataTwo()
                // }
                // if(this.idName6!=""){
                //     this.bottomFourDataTwo()
                // }
                return
            } else if (data == "middleTwo") {
                this.middleTwoDataTwo()
            } else if (data == "middleThree") {
                this.middleThreeDataTwo()
            } else if (data == "middleFour") {
                this.middleFourDataTwo()
            }  else if (data == "bottomTwo") {
                this.bottomTwoDataTwo()
            }  else if (data == "bottomThree") {
                this.bottomThreeDataTwo()
            }   else if (data == "bottomFour") {
                this.bottomFourDataTwo()
            }  
        },

        //本季度开始
        onClick(picker) {
            var now = new Date(); // 当前日期
            var nowMonth = now.getMonth(); // 当前月
            var nowYear = now.getYear(); // 当前年
            nowYear += (nowYear < 2000) ? 1900 : 0;
            let m = 0;
            if (nowMonth < 3) {//012
                m = 0
            } else if (2 < nowMonth && nowMonth < 6) {//345
                m = 3
            } else if (5 < nowMonth && nowMonth < 8) {//678
                m = 6
            } else if (nowMonth > 8) { //9 10 11
                m = 9
            }
            let quarterStart = new Date(nowYear, m, 1)

            this.formatDate(quarterStart)
        },
        //本季度结束
        twoClick(picker) {
            var now = new Date(); // 当前日期
            var nowMonth = now.getMonth(); // 当前月
            var nowYear = now.getYear(); // 当前年
            nowYear += (nowYear < 2000) ? 1900 : 0;
            let i = 0;
            if (nowMonth < 3) {//012
                i = 3
            } else if (2 < nowMonth && nowMonth < 6) {//345
                i = 6
            } else if (5 < nowMonth && nowMonth < 8) {//678
                i = 9
            } else if (nowMonth > 8) { //9 10 11
                i = 0
            }

            let quarterEnd = new Date(nowYear, i, 1).getTime() - (60 * 60 * 24 * 1000)
            let aa = Date(parseInt(quarterEnd) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ')
            this.formatDate(new Date(aa))
        },

        formatDate(date) {
            var myyear = date.getFullYear();
            var mymonth = date.getMonth() + 1;
            var myweekday = date.getDate();
            if (mymonth < 10) {
                mymonth = "0" + mymonth;
            }
            if (myweekday < 10) {
                myweekday = "0" + myweekday;
            }
            this.timerData.push(myyear + "-" + mymonth)
            return (myyear + "-" + mymonth);
        },
        

        changeEchartsDate() {
            this.middleOneData();
            this.middleTwoData();
            this.middleThreeData();
            this.middleFourData();
            this.bottomOneData();
            this.bottomTwoData();
            this.bottomThreeData();
            this.bottomFourData();
            this.getMangeData();
        },
        getMangeData() {
            GetManageDate(this.params).then((res) => {
                this.collectionPeriod = res.Data.AvgIncomeCycle;

                this.customerRate = res.Data.RateRepeatContract * 100;
                this.positionRate = res.Data.PerUnit / 10000;
                this.positionTime = res.Data.DeliveryCycle;
                this.newBillTime = res.Data.StaffOrderCycle;
                this.collectionAmount = conversionUnit(res.Data.IncomeAmount);
            });
        },
        formatter: function (num) {
            return num.toFixed(2);
        },
        handleCompany(v) {
            this.companyId = v.value;
            this.changeEchartsDate();
        },
        handleTime() {
            this.changeEchartsDate();
        },
        // 获取全国大区
        comboBoxData() {
            GetRegionComboBox({ ticket: this.urlData }).then((res) => {
                this.countryValue = res.Data[0].RegionName;
                this.countryId = res.Data[0].Id;
                if (res.Data.length >= 0) {
                    this.checkId = res.Data[0].Id;
                }
                res.Data.forEach((e) => {
                    const item = {
                        value: e.Id,
                        label: e.RegionName,
                    };
                    this.wholeCountry.push(item);
                });
                this.GetCompaniesData();
            });
        },
        handleRegion(v) {
            this.checkId = v.value;
            this.countryId = v.value;
            this.companies = [];
            this.companyValue = "";
            //   this.companyId = 0;
            this.GetCompaniesData();
            this.changeEchartsDate();
        },
        GetCompaniesData() {
            let param = {
                regionId: this.checkId,
                ticket: this.urlData,
            };

            GetCompaniesData(param).then((res) => {
                this.companyValue = res[0].Text;
                this.companyId = res[0].CompanyId
                res.forEach((e) => {
                    const item = {
                        value: e.CompanyId,
                        label: e.Text,
                    };
                    this.companies.push(item);
                });

                this.changeEchartsDate();

            });
        },
        // 员工业绩偏离折线
        middleOneData() {
            let param = this.params;
            GetStaffPerformance(param).then((res) => {
                if (res.Status === 1) {
                    var xData = [];
                    var yData1 = [];
                    var yData2 = [];

                    res.Data.forEach((e) => {
                        xData.push(e.Year);
                        yData1.push((e.PerformanceAmount / 10000).toFixed(2));
                        yData2.push(e.StaffCount);
                    });

                    let middleOne = this.$echarts.init(
                        document.getElementById("middleOne")
                    );
                    middleOne.setOption({
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "cross",
                            },
                        },
                        legend: {
                            //   x: "center",
                            //   y: "40px",
                            textStyle: {
                                color: this.isChildText ? "#000" : "#f2f2f2",
                                fontSize: 12,
                            },
                            bottom: "3%",
                            icon: "roundRect",
                            itemWidth: 10, // 设置宽度
                            itemHeight: 2, // 设置高度
                            data: ["公司业绩(万)", "员工人数(人)"],
                        },
                        grid: {
                            right: "5%",
                            bottom: "13%",
                            left: "2%",
                            top: "5%",
                            containLabel: true,
                        },
                        xAxis: [
                            {
                                type: "category",
                                data: xData,
                                axisTick: {
                                    show: false,
                                },
                                axisLabel: {
                                    interval: 0,
                                    textStyle: {
                                        color: this.isTextColor,
                                    },
                                    // 默认x轴字体大小
                                    fontSize: 12,
                                    // margin:文字到x轴的距离
                                },
                                axisPointer: {
                                    label: {
                                        padding: [0, 0, 10, 0],
                                        // 这里的margin和axisLabel的margin要一致!
                                        margin: 15,
                                        // 移入时的字体大小
                                        fontSize: 12,
                                    },
                                },
                                boundaryGap: false,
                            },
                        ],
                        yAxis: [
                            {
                                type: "value",
                                axisLabel: {
                                    textStyle: {
                                        color: this.isTextColor,
                                    },
                                    interval: 0,
                                    rotate: 25, //代表逆时针旋转45度
                                },
                                splitLine: {
                                    lineStyle: {
                                        color: this.isChildText ? "#000" : "#404666",
                                    },
                                },
                            },
                            {
                                type: "value",
                                position: "right",
                                axisLabel: {
                                    textStyle: {
                                        color: this.isTextColor,
                                    },
                                    formatter: "{value}",
                                    interval: 0,
                                    rotate: -25, //代表逆时针旋转45度
                                },
                                splitLine: {
                                    show: false,
                                },
                            },
                        ],
                        series: [
                            {
                                name: "公司业绩(万)",
                                type: "line",
                                yAxisIndex: 0,
                                symbolSize: 12,
                                itemStyle: {
                                    normal: {
                                        color: "#FC30EE",
                                    },
                                },
                                data: yData1,
                            },
                            {
                                name: "员工人数(人)",
                                type: "line",
                                yAxisIndex: 1,
                                symbolSize: 12,
                                itemStyle: {
                                    normal: {
                                        color: "#0EF100",
                                    },
                                },
                                data: yData2,
                            },
                        ],
                    });
                } else {
                    window.location.href = "http://staff.risfond.com/signin.aspx";
                }
            });
        },

        // 公司业绩等级分布
        middleTwoDataTwo(){
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };
            
            GetRegionalPerformanceGradeByDateRange(param).then((res) => {
                var arrData = [];
                res.Data.forEach((e) => {
                    arrData.push(e.CompanyCount);
                });

                let middleTwo = this.$echarts.init(
                    document.getElementById("middleTwo")
                );
                middleTwo.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "5%",
                        top: "12%",
                        containLabel: true,
                    },
                    tooltip: {
                        //trigger: 'axis',    //显示其他分类
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    xAxis: [
                        {
                            type: "category",
                            axisLabel: {
                                interval: 0,
                                color: this.isTextColor,
                                fontSize: "10",
                            },
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#404666", //左边线的颜色
                                    width: "2", //坐标线的宽度
                                },
                            },
                            data: ["100万以内", "100-500万", "500-1000万", "1000万以上"],
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisLabel: {
                                textStyle: {
                                    color: this.isTextColor,
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: "100万以内",
                            type: "bar",
                            stack: "广告",
                            barWidth: 25,
                            data: [arrData[0]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#FFB377"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "100-500万",
                            type: "bar",
                            stack: "广告",
                            barWidth: 25,
                            data: [0, arrData[1]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#FFB377", "#48E3EC"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "500-1000万",
                            type: "bar",
                            barWidth: 25,
                            stack: "广告",
                            data: [0, 0, arrData[2]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#FFB377", "#48E3EC", "#1B82FF"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "1000万以上",
                            type: "bar",
                            stack: "广告",
                            barWidth: 25,
                            data: [0, 0, 0, arrData[3]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = [
                                            "#FFB377",
                                            "#48E3EC",
                                            "#1B82FF",
                                            "#FF6969",
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        middleTwoData() {
            let param = this.params;
            GetRegionalPerformanceGrade(param).then((res) => {
                var arrData = [];
                res.Data.forEach((e) => {
                    arrData.push(e.CompanyCount);
                });

                let middleTwo = this.$echarts.init(
                    document.getElementById("middleTwo")
                );
                middleTwo.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "5%",
                        top: "12%",
                        containLabel: true,
                    },
                    tooltip: {
                        //trigger: 'axis',    //显示其他分类
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    xAxis: [
                        {
                            type: "category",
                            axisLabel: {
                                interval: 0,
                                color: this.isTextColor,
                                fontSize: "10",
                            },
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#404666", //左边线的颜色
                                    width: "2", //坐标线的宽度
                                },
                            },
                            data: ["100万以内", "100-500万", "500-1000万", "1000万以上"],
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisLabel: {
                                textStyle: {
                                    color: this.isTextColor,
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: "100万以内",
                            type: "bar",
                            stack: "广告",
                            barWidth: 25,
                            data: [arrData[0]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#FFB377"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "100-500万",
                            type: "bar",
                            stack: "广告",
                            barWidth: 25,
                            data: [0, arrData[1]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#FFB377", "#48E3EC"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "500-1000万",
                            type: "bar",
                            barWidth: 25,
                            stack: "广告",
                            data: [0, 0, arrData[2]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#FFB377", "#48E3EC", "#1B82FF"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "1000万以上",
                            type: "bar",
                            stack: "广告",
                            barWidth: 25,
                            data: [0, 0, 0, arrData[3]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = [
                                            "#FFB377",
                                            "#48E3EC",
                                            "#1B82FF",
                                            "#FF6969",
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        // 回款客户等级分布
        middleThreeDataTwo(){
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };
            GetRegionalClientGradeIncomeCycleByDateRange(param).then((res) => {
                var arr = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.ClientGrade,
                        value: e.IncomeAmountCycle,
                    };
                    arr.push(item);
                });

                let middleThree = this.$echarts.init(
                    document.getElementById("middleThree")
                );

                let color = ["#1C82FF", "#8993FF", "#1FFD8A", "#F8D135"];
                let echartData = arr;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };

                middleThree.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        top: "5%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        y: "bottom",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            rich: {
                                name: {
                                    fontSize: 10,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "50%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        middleThreeData() {
            let param = this.params;
            GetRegionalClientGrade(param).then((res) => {
                var arr = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.ClientGrade,
                        value: e.ClientCount,
                    };
                    arr.push(item);
                });

                let middleThree = this.$echarts.init(
                    document.getElementById("middleThree")
                );

                let color = ["#1C82FF", "#8993FF", "#1FFD8A", "#F8D135"];
                let echartData = arr;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };

                middleThree.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        top: "5%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        y: "bottom",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            rich: {
                                name: {
                                    fontSize: 10,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "50%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        // 客户回款客单价分布
        middleFourDataTwo(){
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };
            GetRegionalClientUnitPriceByDateRange(param).then((res) => {
                var arrGrade = [];
                var arrData1 = [];
                var arrData2 = [];
                var arrData3 = [];
                res.Data.forEach((e) => {
                    arrGrade.push(e.ClientGrade);
                    arrData1.push((e.IncomeAmount / 10000).toFixed(2));
                    arrData2.push(e.EntryCount);
                    arrData3.push((e.CustomerUnitPrice / 10000).toFixed(2));
                });

                let middleFour = this.$echarts.init(
                    document.getElementById("middleFour")
                );
                var datax = arrGrade;
                var datay = arrData1;
                var datay2 = arrData2;
                var datay3 = arrData3;

                var color = ["#8993FF", "#1FFD8A", "#F8D135", "#00F2DD"];
                var data = [
                    [datay2[0], datay3[0], datax[0], datay[0]],
                    [datay2[1], datay3[1], datax[1], datay[1]],
                    [datay2[2], datay3[2], datax[2], datay[2]],
                    [datay2[3], datay3[3], datax[3], datay[3]],
                ];
                // 中心线
                var centerLine = [
                    {
                        name: "y",
                        xAxis: 40,
                    },
                    {
                        name: "x",
                        yAxis: 40,
                    },
                ];

                middleFour.setOption({
                    dataset: [
                        {
                            source: data,
                        },
                    ],
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "2%",
                        top: "8%",
                        containLabel: true,
                    },
                    legend: {
                        type: "",
                        show: false,
                        orient: "vertical",
                        icon: "rect",
                        x: "center",
                        y: "bottom",
                        bottom: "5%",
                        data: [
                            {
                                name: "v0",
                                icon: "circle",
                                textStyle: {
                                    color: "#fff", // 图例文字颜色
                                },
                            },
                            {
                                name: "v1-v2",
                                icon: "circle",
                                textStyle: {
                                    color: "#fff", // 图例文字颜色
                                },
                            },
                        ],
                        itemWidth: 10,
                        itemHeight: 5,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            rich: {
                                name: {
                                    fontSize: 10,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    tooltip: {
                        trigger: "axis",
                        formatter: function (value) {
                            return (
                                value[0].data[2] + "客单价" + ":" + value[0].data[1] + "万"
                            );
                        },
                        axisPointer: {
                            type: "cross",
                        },
                    },
                    xAxis: {
                        type: "category",
                        position: "bottom",
                        boundaryGap: ["20%", "20%"], // 两侧留白
                        nameLocation: "end",
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        axisLabel: {
                            color: this.isTextColor, // x轴名称颜色
                            fontSize: "10",
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                type: "dashed",
                            },
                        },
                    },
                    //   yAxis: {
                    //     splitLine: {
                    //       show: true,
                    //       lineStyle: {
                    //         color: "#404666",
                    //       },
                    //     },
                    //     axisLabel: {
                    //       color: this.isTextColor,

                    //       formatter: function (value) {
                    //         var texts = [];
                    //         if (value == 0) {
                    //           texts.push(0);
                    //         } else if (value > 1) {
                    //           texts.push(datay[0]);
                    //         } else if (value <= 2) {
                    //           texts.push(datay[1]);
                    //         } else if (value <= 3) {
                    //           texts.push(datay[2]);
                    //         } else {
                    //           texts.push(datay[3]);
                    //         }
                    //         return texts;
                    //       },

                    //     },
                    //   },
                    yAxis: {
                        type: "value",
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        axisLabel: {
                            // interval: 0,
                            // rotate: 40,
                            textStyle: {
                                fontFamily: "Microsoft YaHei",
                                color: this.isTextColor,
                            },
                        },
                    },
                    series: [
                        {
                            name: "v0",
                            data: data,
                            type: "scatter",
                            symbolSize: function (data) {
                                if (data[1] > 50) {
                                    data[1] * 23;
                                } else {
                                    data[1] * 230;
                                }

                                for (var i = 0; i > data.length; i++) { }

                                return data[1] * 7;
                            },

                            itemStyle: {
                                color: function (param) {
                                    return color[param.dataIndex];
                                },
                            },
                            markLine: {
                                silent: true, // 是否不响应鼠标事件
                                precision: 2, // 精度
                                lineStyle: {
                                    type: "solid",
                                    color: "#fff",
                                },
                                label: {
                                    color: "#fff",
                                    position: "end",
                                    formatter: "{b}",
                                },
                                data: [
                                    {
                                        name: "y",
                                        xAxis: 40,
                                    },
                                    {
                                        name: "x",
                                        yAxis: 40,
                                    },
                                ],
                            },
                        },

                        //   {
                        //     name: "v1-v2",
                        //     type: "scatter",
                        //     symbolSize: function (data) {
                        //       return data[1] * 10;
                        //     },
                        //     itemStyle: {
                        //       color: function (param) {
                        //         return color[param.dataIndex];
                        //       },
                        //     },
                        //   },
                        //   {
                        //     name: "v3-v4",
                        //     type: "scatter",
                        //     symbolSize: function (data) {
                        //       return data[1] * 10;
                        //     },
                        //     itemStyle: {
                        //       color: function (param) {
                        //         return color[param.dataIndex];
                        //       },
                        //     },
                        //   },
                        //   {
                        //     name: "v5",
                        //     type: "scatter",
                        //     symbolSize: function (data) {
                        //       return data[1] * 10;
                        //     },
                        //     itemStyle: {
                        //       color: function (param) {
                        //         return color[param.dataIndex];
                        //       },
                        //     },
                        //   },
                    ],
                });
            });

        },
        middleFourData() {
            let param = this.params;
            GetRegionalClientUnitPrice(param).then((res) => {
                var arrGrade = [];
                var arrData1 = [];
                var arrData2 = [];
                var arrData3 = [];
                res.Data.forEach((e) => {
                    arrGrade.push(e.ClientGrade);
                    arrData1.push((e.IncomeAmount / 10000).toFixed(2));
                    arrData2.push(e.EntryCount);
                    arrData3.push((e.CustomerUnitPrice / 10000).toFixed(2));
                });

                let middleFour = this.$echarts.init(
                    document.getElementById("middleFour")
                );
                var datax = arrGrade;
                var datay = arrData1;
                var datay2 = arrData2;
                var datay3 = arrData3;

                var color = ["#8993FF", "#1FFD8A", "#F8D135", "#00F2DD"];
                var data = [
                    [datay2[0], datay3[0], datax[0], datay[0]],
                    [datay2[1], datay3[1], datax[1], datay[1]],
                    [datay2[2], datay3[2], datax[2], datay[2]],
                    [datay2[3], datay3[3], datax[3], datay[3]],
                ];
                // 中心线
                var centerLine = [
                    {
                        name: "y",
                        xAxis: 40,
                    },
                    {
                        name: "x",
                        yAxis: 40,
                    },
                ];

                middleFour.setOption({
                    dataset: [
                        {
                            source: data,
                        },
                    ],
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "2%",
                        top: "8%",
                        containLabel: true,
                    },
                    legend: {
                        type: "",
                        show: false,
                        orient: "vertical",
                        icon: "rect",
                        x: "center",
                        y: "bottom",
                        bottom: "5%",
                        data: [
                            {
                                name: "v0",
                                icon: "circle",
                                textStyle: {
                                    color: "#fff", // 图例文字颜色
                                },
                            },
                            {
                                name: "v1-v2",
                                icon: "circle",
                                textStyle: {
                                    color: "#fff", // 图例文字颜色
                                },
                            },
                        ],
                        itemWidth: 10,
                        itemHeight: 5,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            rich: {
                                name: {
                                    fontSize: 10,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    tooltip: {
                        trigger: "axis",
                        formatter: function (value) {
                            return (
                                value[0].data[2] + "客单价" + ":" + value[0].data[1] + "万"
                            );
                        },
                        axisPointer: {
                            type: "cross",
                        },
                    },
                    xAxis: {
                        type: "category",
                        position: "bottom",
                        boundaryGap: ["20%", "20%"], // 两侧留白
                        nameLocation: "end",
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        axisLabel: {
                            color: this.isTextColor, // x轴名称颜色
                            fontSize: "10",
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                type: "dashed",
                            },
                        },
                    },
                    //   yAxis: {
                    //     splitLine: {
                    //       show: true,
                    //       lineStyle: {
                    //         color: "#404666",
                    //       },
                    //     },
                    //     axisLabel: {
                    //       color: this.isTextColor,

                    //       formatter: function (value) {
                    //         var texts = [];
                    //         if (value == 0) {
                    //           texts.push(0);
                    //         } else if (value > 1) {
                    //           texts.push(datay[0]);
                    //         } else if (value <= 2) {
                    //           texts.push(datay[1]);
                    //         } else if (value <= 3) {
                    //           texts.push(datay[2]);
                    //         } else {
                    //           texts.push(datay[3]);
                    //         }
                    //         return texts;
                    //       },

                    //     },
                    //   },
                    yAxis: {
                        type: "value",
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        axisLabel: {
                            // interval: 0,
                            // rotate: 40,
                            textStyle: {
                                fontFamily: "Microsoft YaHei",
                                color: this.isTextColor,
                            },
                        },
                    },
                    series: [
                        {
                            name: "v0",
                            data: data,
                            type: "scatter",
                            symbolSize: function (data) {
                                if (data[1] > 50) {
                                    data[1] * 23;
                                } else {
                                    data[1] * 230;
                                }

                                for (var i = 0; i > data.length; i++) { }

                                return data[1] * 7;
                            },

                            itemStyle: {
                                color: function (param) {
                                    return color[param.dataIndex];
                                },
                            },
                            markLine: {
                                silent: true, // 是否不响应鼠标事件
                                precision: 2, // 精度
                                lineStyle: {
                                    type: "solid",
                                    color: "#fff",
                                },
                                label: {
                                    color: "#fff",
                                    position: "end",
                                    formatter: "{b}",
                                },
                                data: [
                                    {
                                        name: "y",
                                        xAxis: 40,
                                    },
                                    {
                                        name: "x",
                                        yAxis: 40,
                                    },
                                ],
                            },
                        },

                        //   {
                        //     name: "v1-v2",
                        //     type: "scatter",
                        //     symbolSize: function (data) {
                        //       return data[1] * 10;
                        //     },
                        //     itemStyle: {
                        //       color: function (param) {
                        //         return color[param.dataIndex];
                        //       },
                        //     },
                        //   },
                        //   {
                        //     name: "v3-v4",
                        //     type: "scatter",
                        //     symbolSize: function (data) {
                        //       return data[1] * 10;
                        //     },
                        //     itemStyle: {
                        //       color: function (param) {
                        //         return color[param.dataIndex];
                        //       },
                        //     },
                        //   },
                        //   {
                        //     name: "v5",
                        //     type: "scatter",
                        //     symbolSize: function (data) {
                        //       return data[1] * 10;
                        //     },
                        //     itemStyle: {
                        //       color: function (param) {
                        //         return color[param.dataIndex];
                        //       },
                        //     },
                        //   },
                    ],
                });
            });
        },

        // 全国招聘数据
        bottomOneData() {
            let param = this.params;
            GetStaffCount(param).then((res) => {
                var arrdata1 = [];
                var arrdata2 = [];
                var arrdata3 = [];
                var arrdata4 = [];
                var arrdata5 = [];
                res.Data.forEach((e) => {
                    arrdata1.push(e.StaffTargetCount);
                    arrdata2.push(e.StaffEntryCount);
                    arrdata3.push(e.StaffLeaveCount);
                    arrdata4.push(e.StaffCount);
                    arrdata5.push(e.Year);
                });

                let bottomOne = this.$echarts.init(
                    document.getElementById("bottomOne")
                );
                bottomOne.setOption({
                    tooltip: {
                        trigger: "axis",
                        formatter:
                            "{b}<br/>目标 : {c0}人<br/>入职 : {c1}人<br/>离职 : {c2}人<br/>实际在职 : {c3}人",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    grid: {
                        left: "2%",
                        right: "4%",
                        bottom: "15%",
                        top: "4%",
                        containLabel: true,
                    },
                    legend: {
                        data: ["目标", "入职", "离职", "实际在职"],
                        right: "0%",
                        bottom: "2%",
                        left: "center",
                        textStyle: {
                            fontSize: 10,
                            color: this.isTextColor,
                        },
                        itemWidth: 10,
                        itemHeight: 10,
                        // itemGap: 35
                    },
                    xAxis: {
                        type: "category",
                        data: arrdata5,
                        axisLine: {
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        axisLabel: {
                            // interval: 0,
                            // rotate: 40,
                            textStyle: {
                                fontFamily: "Microsoft YaHei",
                                color: this.isTextColor,
                            },
                        },
                    },

                    yAxis: {
                        type: "value",
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        axisLabel: {
                            // interval: 0,
                            // rotate: 40,
                            textStyle: {
                                fontFamily: "Microsoft YaHei",
                                color: this.isTextColor,
                            },
                        },
                    },
                    // "dataZoom": [{
                    //   "show": true,
                    //   "height": 12,
                    //   "xAxisIndex": [
                    //     0
                    //   ],
                    //   bottom:'8%',
                    //   "start": 10,
                    //   "end": 90,
                    //   handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
                    //   handleSize: '110%',
                    //   handleStyle:{
                    //     color:"#d3dee5",

                    //   },
                    //   textStyle:{
                    //     color:"#fff"},
                    //   borderColor:"#90979c"
                    // }, {
                    //   "type": "inside",
                    //   "show": true,
                    //   "height": 15,
                    //   "start": 1,
                    //   "end": 35
                    // }],
                    series: [
                        {
                            name: "目标",
                            type: "bar",
                            barWidth: 15,
                            itemStyle: {
                                normal: {
                                    color: "#00F2DD",
                                },
                            },
                            data: arrdata1,
                        },
                        {
                            name: "入职",
                            type: "bar",
                            barWidth: 15,
                            itemStyle: {
                                normal: {
                                    color: "#1C82FF",
                                },
                            },
                            data: arrdata2,
                        },
                        {
                            name: "离职",
                            type: "bar",
                            barWidth: 15,
                            itemStyle: {
                                normal: {
                                    color: "#F8D135",
                                },
                            },
                            data: arrdata3,
                        },
                        {
                            name: "实际在职",
                            type: "bar",
                            barWidth: 15,
                            itemStyle: {
                                normal: {
                                    color: "#FF6969",
                                },
                            },
                            data: arrdata4,
                        },
                    ],
                });
            });
        },
        // 员工职级分布
        bottomTwoDataTwo() {
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };
            GetRegionalCounselorPositionByDateRange(param).then((res) => {
                let echartData = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.Position,
                        value: e.StaffCount,
                    };
                    echartData.push(item);
                });
                let bottomTwo = this.$echarts.init(
                    document.getElementById("bottomTwo")
                );
                let color = ["#8993FF", "#F8D135", "#9CFFE8", "#FF6969"];

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomTwo.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "5%",
                        top: "2%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        y: "bottom",
                        bottom: "2%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 12,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "50%"],
                            data: echartData,
                            hoverAnimation: true,
                            itemStyle: {
                                normal: {
                                    borderWidth: 0,
                                },
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],

                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });

        },
        bottomTwoData() {
            let param = this.params;
            GetRegionalCounselorPosition(param).then((res) => {
                let echartData = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.Position,
                        value: e.StaffCount,
                    };
                    echartData.push(item);
                });
                let bottomTwo = this.$echarts.init(
                    document.getElementById("bottomTwo")
                );
                let color = ["#8993FF", "#F8D135", "#9CFFE8", "#FF6969"];

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomTwo.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "5%",
                        top: "2%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        y: "bottom",
                        bottom: "2%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 12,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "50%"],
                            data: echartData,
                            hoverAnimation: true,
                            itemStyle: {
                                normal: {
                                    borderWidth: 0,
                                },
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],

                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        // 员工学历分布
        bottomThreeDataTwo(){
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };
            GetRegionalStaffEducationByDateRange(param).then((res) => {
                let echartData = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.EducationText,
                        value: e.StaffCount,
                    };
                    echartData.push(item);
                });
                let bottomThree = this.$echarts.init(
                    document.getElementById("bottomThree")
                );
                let color = ["#FF6969", "#1C82FF", "#1FFD8A", "#F8D135", "#00F2DD"];

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomThree.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "5%",
                        top: "1%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "2%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 12,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "50%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        bottomThreeData() {
            let param = this.params;
            GetRegionalStaffEducation(param).then((res) => {
                let echartData = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.EducationText,
                        value: e.StaffCount,
                    };
                    echartData.push(item);
                });
                let bottomThree = this.$echarts.init(
                    document.getElementById("bottomThree")
                );
                let color = ["#FF6969", "#1C82FF", "#1FFD8A", "#F8D135", "#00F2DD"];

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomThree.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "5%",
                        top: "1%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "2%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 12,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "50%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        // 不同周期离职人数GetRegionalStaffLeaveCycle
        bottomFourDataTwo(){
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0]+"-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };
            GetRegionalStaffLeaveCycleByDateRange(param).then((res) => {
                let echartData = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.LeaveCycle,
                        value: e.StaffCount,
                    };
                    echartData.push(item);
                });

                let bottomFour = this.$echarts.init(
                    document.getElementById("bottomFour")
                );
                let color = [
                    "#62A8FD",
                    "#1FFD8A",
                    "#1C82FF",
                    "#F8D135",
                    "#FFB377",
                    "#9CFFE8",
                ];

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomFour.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "8%",
                        top: "2%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        //   scrollDataIndex: 3,
                        pageTextStyle: {
                            color: this.isTextColor, //翻页数字颜色
                        }, //翻页数字设置
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "2%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 12,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "50%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                    toolbox: {
                        show: false,
                        feature: {
                            saveAsImage: {},
                        },
                    },
                });
            });
        },
        bottomFourData() {
            let param = this.params;
            GetRegionalStaffLeaveCycle(param).then((res) => {
                let echartData = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.LeaveCycle,
                        value: e.StaffCount,
                    };
                    echartData.push(item);
                });

                let bottomFour = this.$echarts.init(
                    document.getElementById("bottomFour")
                );
                let color = [
                    "#62A8FD",
                    "#1FFD8A",
                    "#1C82FF",
                    "#F8D135",
                    "#FFB377",
                    "#9CFFE8",
                ];

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomFour.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "8%",
                        top: "2%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        //   scrollDataIndex: 3,
                        pageTextStyle: {
                            color: this.isTextColor, //翻页数字颜色
                        }, //翻页数字设置
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "2%",
                        itemWidth: 10,
                        itemHeight: 10,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            fontSize: 10,
                            rich: {
                                name: {
                                    fontSize: 12,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "50%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    color: this.isTextColor,
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: this.isTextColor,
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: this.isTextColor,
                                        },
                                    },
                                },
                            },
                        },
                    ],
                    toolbox: {
                        show: false,
                        feature: {
                            saveAsImage: {},
                        },
                    },
                });
            });
        },
        changeTextColor(status) {
            this.isChildText = status;
        },
        changIconsBlockPosition(str, index) {
            if (str === "enter") {
                if (index === 0) {
                    this.$refs.iconsNin.$el.classList.add("icon-nin-act");
                }
                if (index === 1) {
                    this.$refs.iconsFir.$el.classList.add("cont-position-act");
                }
                if (index == 2) {
                    this.$refs.iconsSec.$el.classList.add("cont-position-act");
                }
                if (index == 3) {
                    this.$refs.iconsThr.$el.classList.add("cont-position-act");
                }
                if (index == 4) {
                    this.$refs.iconsFou.$el.classList.add("cont-position-act");
                }
                if (index == 5) {
                    this.$refs.iconsFiv.$el.classList.add("cont-position-act");
                }
                if (index == 6) {
                    this.$refs.iconsSix.$el.classList.add("cont-position-act");
                }
                if (index == 7) {
                    this.$refs.iconsSev.$el.classList.add("cont-position-act");
                }
                if (index == 8) {
                    this.$refs.iconsEig.$el.classList.add("cont-position-act");
                }
            } else {
                this.$refs.iconsFir.$el.classList.remove("cont-position-act");
                this.$refs.iconsSec.$el.classList.remove("cont-position-act");
                this.$refs.iconsThr.$el.classList.remove("cont-position-act");
                this.$refs.iconsFou.$el.classList.remove("cont-position-act");
                this.$refs.iconsFiv.$el.classList.remove("cont-position-act");
                this.$refs.iconsSix.$el.classList.remove("cont-position-act");
                this.$refs.iconsSev.$el.classList.remove("cont-position-act");
                this.$refs.iconsEig.$el.classList.remove("cont-position-act");
                this.$refs.iconsNin.$el.classList.remove("icon-nin-act");
            }
        },
        download(idName, imgName = "chart") {
            exportImg(idName, imgName);
        },
    },
};
</script>

<style scoped>
.icons-text-block {
    position: relative;
    display: flex;
    overflow: hidden;
    justify-content: space-between;
}

.icons-info {
    position: relative;
}

.icon-nin {
    position: absolute;
    right: -34px;
    transition: all 0.3s linear;
}

.icon-nin-act {
    right: 14px;
}

.collection {
    width: 100vw;
    height: 100vh;
    display: flex;
}

.container {
    height: 100vh;
    padding: 19px 32px;
}

.top-border {
    padding: 16px;
    color: #fff;
    height: 84%;
}

.icon-four {
    background: url(../../assets/img/cont-bg-four.png) no-repeat;
}

.icon-six {
    background: url(../../assets/img/cont-bg-six.png) no-repeat;
}

.top-icon {
    padding: 5px 92px 5px 12px;
    display: inline-block;
    letter-spacing: 1px;
    font-size: 16px;
    /* min-width: 92px; */
    background-size: 100%;
    /* position: absolute; */
    /* text-align: center; */
    background-position: center;
    height: 32px;
    line-height: 32px;
}

.cont-bg-event {
    width: 180px;
    display: inline-block;
    padding: 5px 52px 5px 12px;
    background: url(../../assets/img/cont-bg-eight.png) no-repeat;
    letter-spacing: 1px;
    font-size: 16px;
    /* min-width: 172px; */
    background-size: 100%;
    /* position: absolute; */
    /* text-align: center; */
    background-position: center;
    height: 32px;
    line-height: 32px;
}

>>>.el-input__inner {
    background: none !important;
    border: 1px solid #1ac9ff !important;
    color: #fff;
}

>>>.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
    background-color: #1e4472 !important;
    color: #ffffff;
}

.el-date-editor .el-range-input {
    background: none !important;
}

>>>.el-date-editor .el-range-input {
    background: none !important;
}

>>>.el-popper[x-placement^="bottom"] {
    margin-top: 0 !important;
}

>>>.el-select-dropdown {
    background-color: none !important;
}

>>>.el-select-dropdown__item.selected {
    background: #1c82ff !important;
    color: #fff;
}

>>>.el-picker-panel {
    background: none !important;
    color: #fff;
}

>>>.el-month-table td .cell,
.el-date-editor .el-range-separator {
    color: #fff;
}

.top-select {
    margin-bottom: 15px;
}

.top-cont {
    width: 100%;
    height: 20%;
}

.middle-cont {
    width: 100%;
    height: 30%;
    margin: 0.8em 0;
    display: flex;
    justify-content: space-between;
}

.middle-block {
    width: 24%;
    height: 100%;
}

.bottom-cont {
    width: 100%;
    height: 28%;
}

/* 阴影 */
>>>.dv-border-box-7 .dv-border-svg-container>polyline {
    stroke: #1eb0fc;
}

>>>.dv-border-box-7 {
    box-shadow: 0px 0px 10px 0px #7580be inset !important;
}

>>>.dv-border-box-7:hover {
    box-shadow: 0px 0px 10px 0px #ffdf38 inset !important;
}

>>>.dv-border-box-7 .dv-border-svg-container>polyline:nth-child(2),
>>>.dv-border-box-7 .dv-border-svg-container>polyline:nth-child(4) {
    display: none !important;
}

>>>.dv-border-box-7 .dv-bb7-line-width-5 {
    display: none !important;
}

>>>.dv-border-box-7 .dv-bb7-line-width-2 {
    stroke-width: 4;
}

>>>.dv-border-box-7:hover .right-top polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .left-top polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .right-bottom polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .left-bottom polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

/* 顶部 */
.top-data {
    display: flex;
    justify-content: space-between;
    height: 70%;
    align-items: center;
}

.top-num1 {
    width: 16.6666%;
    text-align: center;
    display: flex;
    justify-content: center;
}

.top-line {
    border-left: 1px solid #404666;
}

.top-num {
    font-weight: 600;
    color: #ffdf38;
    line-height: 30px;
    letter-spacing: 1px;
    font-size: 34px;
    font-family: PingFangSC-Semibold, PingFang SC;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    word-break: break-all;
}

.top-text1 {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    letter-spacing: 1px;
    text-align: center;
    margin-top: 15px;
}

/* 中间 */
.middle-data {
    padding: 16px 16px 0 16px;
    color: #fff;
    /* position: absolute; */
}

.width-height {
    width: 100%;
    height: 80%;
}

.middle-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
}

.cont-position {
    position: relative;
    left: 112px;
    transition: all 0.3s linear;
}

.cont-position-act {
    left: 0px;
}

.icons-block {
    overflow: hidden;
    margin-right: 6px;
    padding: 4px 2px;
    position: absolute;
    right: 8px;
}

@media (min-width: 1279px) and (max-width: 1365px) {
    .container {
        height: 90vh;
        padding: 15px 15px;
    }

    .top-cont {
        height: 20%;
    }

    .middle-cont {
        height: 33%;
    }

    .bottom-cont {
        height: 33%;
    }

    .top-border {
        padding: 8px;
    }

    .middle-data {
        padding: 5px 8px 0 8px;
    }

    .top-icon {
        font-size: 12px;
        padding: 0 70px 0 12px;
    }

    .cont-bg-event {
        font-size: 12px;
        width: 120px;
    }
}

@media (max-width: 1365px) {
    .top-num {
        width: 172px !important;
        line-height: 20px;
        font-size: 18px;
    }

    .top-text1 {
        font-size: 14px;
        margin-top: 4px;
    }
    
}

.legendData {
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}

.legendData span {
    margin: 0 5px;
    font-size: 12px;
    list-style: none;
    font-family: initial;
}

.legendData span i {
    display: inline-block;
    width: 10px;
    height: 5px;
}

.legendData span .legendOne {
    background: #8993ff;
}

.legendData span .legendTwo {
    background: #1ffd8a;
}

.legendData span .legendThree {
    background: #f8d135;
}

.legendData span .legendFour {
    background: #00f2dd;
}
</style>

<style>
@media (max-width: 1365px) {

    .el-date-editor--monthrange.el-input, .el-date-editor--monthrange.el-input__inner{
        width: 240px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/dataChart/management.vue